import React from 'react';
import CadastroDeUsuarioAdd from './add';

export default function CadastroDeUsuario() {
  return (
    <main>
      <CadastroDeUsuarioAdd />
    </main>
  );
}
